export default function Wordmark() {
  return (
    <span className="inline-flex items-center gap-3">
      <span className="grid h-10 w-10 place-items-center rounded-lg bg-navy ring-1 ring-white/15" aria-hidden="true">
        <svg viewBox="0 0 64 64" className="h-5 w-5" fill="none">
          <path d="M17 23h26M17 32h19M17 41h23" stroke="#38BDF8" strokeWidth="5" strokeLinecap="round" />
          <circle cx="45" cy="41" r="5" fill="#00A8E8" />
        </svg>
      </span>
      <span className="leading-none">
        <span className="block font-display text-lg font-extrabold tracking-[0.06em] text-white">GSMG</span>
        <span className="mt-1 block font-mono text-[9px] uppercase tracking-[0.32em] text-sky-300">Investments</span>
      </span>
    </span>
  );
}
